import api from './api';

const petsService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.petTypeId) queryParams.append('petTypeId', params.petTypeId);
    if (params.breedId) queryParams.append('breedId', params.breedId);
    if (params.gender) queryParams.append('gender', params.gender);
    if (params.stateId) queryParams.append('stateId', params.stateId);
    if (params.cityId) queryParams.append('cityId', params.cityId);
    // admin list needs a stable order across pages (feed shuffles by default)
    queryParams.append('shuffle', 'false');

    const response = await api.get(`/pets?${queryParams.toString()}`);
    return response.data;
  },
};

export default petsService;
